module.exports = __webpack_public_path__ + "media/images/hybrid-raid-manager-screenshot-1-7c2e5e9dfeb006aa3aa81a41acbfb5ea.jpg";